import { startAuthAttempt } from '@aibees/shared/auth';
import { useMount, usePostHog } from '@aibees/shared/hooks';
import { useSearchParams } from '@aibees/shared/router';
import { ErrorCard } from './components/error-card';
import { SignInLoading } from './components/sign-in-loading';

type AuthEvent = 'AUTH_LOGINVIEW_MOUNT';

export function LoginView() {
  const params = useSearchParams();
  const { code, error, error_description } = params;
  const { track } = usePostHog<AuthEvent>();
  const branch = error ? 'error' : !code ? 'no_code' : 'signin';

  // CU-86e17r1cr: temporary telemetry to diagnose stuck sign-in. Remove the
  // useMount block, the AuthEvent type, and the usePostHog/useMount/startAuthAttempt
  // imports once the investigation closes.
  useMount(() => {
    const attemptId = startAuthAttempt();
    track('AUTH_LOGINVIEW_MOUNT', {
      attemptId,
      branch,
      hasCode: !!code,
      hasError: !!error,
      hasState: !!params.state,
      codeLength: typeof code === 'string' ? code.length : 0,
      urlParamKeys: Object.keys(params),
      pathname: globalThis.location?.pathname,
      referrer: globalThis.document?.referrer || undefined,
      error: error ? String(error) : undefined,
      errorDescription: error_description
        ? String(error_description)
        : undefined,
    });
  });

  if (branch === 'error')
    return <ErrorCard message={String(error_description || error)} />;

  if (branch === 'no_code')
    return <ErrorCard message="Invalid code provided" />;

  return <SignInLoading code={String(code)} />;
}
